var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSchedule(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.99419 0.166626C2.77419 0.166626 0.166687 2.77996 0.166687 5.99996C0.166687 9.21996 2.77419 11.8333 5.99419 11.8333C9.22002 11.8333 11.8334 9.21996 11.8334 5.99996C11.8334 2.77996 9.22002 0.166626 5.99419 0.166626ZM6.00002 10.6666C3.42169 10.6666 1.33335 8.57829 1.33335 5.99996C1.33335 3.42163 3.42169 1.33329 6.00002 1.33329C8.57835 1.33329 10.6667 3.42163 10.6667 5.99996C10.6667 8.57829 8.57835 10.6666 6.00002 10.6666ZM6.29169 3.08329H5.41669V6.58329L8.47919 8.42079L8.91669 7.70329L6.29169 6.14579V3.08329Z",
    fill: "#707070"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSchedule);
export default __webpack_public_path__ + "static/media/schedule.72ea6a6c0f144202f8811ccb6d7d8097.svg";
export { ForwardRef as ReactComponent };